import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'reactstrap';
import { Redirect, Link } from "react-router-dom";
import CronTaskForm from '../CronTaskForm/CronTaskForm';
import PageTitle from '../../../components/PageTitle/PageTitle';
import { startCreateCronTask, createCronTask } from '../../../redux/modules/cron_tasks';

const CronTaskCreate = () => {
    const { t }    = useTranslation();
    const dispatch = useDispatch();
    const {
        cron_taskSuccessfullyCreated,
        cron_task
    } = useSelector(state => state.cron_tasks);

    useEffect(() => {
        dispatch(startCreateCronTask());
    }, [dispatch])

    const submit = (values) => {
        dispatch(createCronTask(values));
    }

    let title = <span>{t('cron_tasks.add')}</span>;

    const actions =
        <Button tag={Link} to="/cron_tasks" color="warning" size="sm">
            <i className="fa fa-arrow-left"></i>&nbsp;{ t('common.back')}
        </Button>

    return (
        <div className="CronTaskCreate">
            <PageTitle icon="tasks" title={ title } actions={ actions } />

            {(cron_taskSuccessfullyCreated && cron_task) &&
                <Redirect to={`/cron_tasks/edit/${cron_task._id}`}/>
            }

            <CronTaskForm cron_task={cron_task} onSubmit={submit} isCreation="true" />
        </div>
    );
}

export default CronTaskCreate;
